import styled from '@emotion/styled';
import { Paper, Typography } from '@mui/material';

import { customPalette } from '../../styles/theme';

export const DevInfoContainer = styled.div`
  border-left: 4px solid ${customPalette.positive.main};
  background: ${customPalette.accent.white};
  padding: 16px;
  margin-bottom: 20px;
  border-radius: 4px;
  max-width: 70%;
  font-size: 14px;
`;

export const DevInfoText = styled(Typography)`
  color: ${customPalette.grey[800]};
  font-size: 14px;
  line-height: 1.5;
`;

export const TestingToolContainer = styled(Paper)`
  padding: 20px;
  margin-top: 20px;
  max-width: 70%;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;

  button {
    max-width: 200px;
  }
`;

export const TestingToolTitle = styled(Typography)`
  font-size: 18px;
  font-weight: 600;
  color: ${customPalette.grey.main};
  margin-bottom: 16px;
`;

export const FormHeaderBar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: ${customPalette.grey[0]};
  padding: 10px;
  text-align: center;
  z-index: 1301;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const FormHeaderTitle = styled(Typography)`
  font-size: 18px;
  font-weight: 600;
  color: ${customPalette.positive.main};
`;
